import { IconButton, useTheme } from "@mui/material";
import { Trash2, X } from "lucide-react";
import type { MouseEvent } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

const ICON_GLYPH_SIZE = 16;

type Props = {
	onRemove: () => void;
	appearance: "flat" | "card";
};

export const ReminderRemoveButton = ({ onRemove, appearance }: Props) => {
	const { t } = useResource();
	const theme = useTheme();

	const handleClick = (e: MouseEvent) => {
		e.stopPropagation();
		onRemove();
	};

	if (appearance === "flat") {
		return (
			<IconButton
				component="span"
				variant="ghost"
				aria-label={t(Resources.Reminders.Actions.remove)}
				onClick={handleClick}
				sx={{ flexShrink: 0 }}
			>
				<Trash2 size={ICON_GLYPH_SIZE} color={theme.palette.grey[400]} />
			</IconButton>
		);
	}

	return (
		<IconButton
			aria-label={t(Resources.Reminders.Actions.remove)}
			onClick={handleClick}
			sx={{ bgcolor: theme.palette.grey[200] }}
		>
			<X size={ICON_GLYPH_SIZE} color={theme.palette.grey[600]} />
		</IconButton>
	);
};
